<template>
    <li class="navbar-text"> | </li>
</template>

<script>
export default {
    name: "TopBarDivider"
}
</script>
